<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    width="650"
    placement="right"
    :closable="true"
    @close="close"
    :visible="visible"
    style="height: 100%;overflow: auto;">

    <a-form>
      <a-form-item label="所拥有的权限">
        <a-tree
          checkable
          @check="onCheck"
          :checkedKeys="checkedKeys"
          :treeData="treeData"
          @expand="onExpand"
          :expandedKeys="expandedKeysss"
          :checkStrictly="checkStrictly">
          <span slot="hasDatarule" slot-scope="{slotTitle,icon}">
            {{ slotTitle }}<a-icon v-if="icon" type="align-left" style="margin-left:5px;color: red;"></a-icon>
          </span>
        </a-tree>
      </a-form-item>
    </a-form>

    <div class="drawer-bootom-button">
      <a-button @click="close" style="margin-right: .8rem">取消</a-button>
      <a-popconfirm title="确定提交？" @confirm="handleSubmit" okText="确定" cancelText="取消" :loading="loading">
        <a-button type="primary">提交</a-button>
      </a-popconfirm>
    </div>


  </a-drawer>

</template>
<script>
import { queryRolePermission, saveRolePermission } from '@/baseAPI/role'
import { getPermissionTree } from '@/baseAPI/memuSetting'

export default {
  name: 'RoleModal',
  data () {
    return {
      roleId: '',
      treeData: [],
      defaultCheckedKeys: [],
      checkedKeys: [],
      expandedKeysss: [],
      allTreeKeys: [],
      autoExpandParent: true,
      checkStrictly: true,
      title: '角色权限配置',
      visible: false,
      loading: false
    }
  },
  methods: {
    onCheck (o) {
      if (this.checkStrictly) {
        this.checkedKeys = o.checked
      } else {
        this.checkedKeys = o
      }
    },
    show (roleId) {
      this.roleId = roleId
      this.visible = true
    },
    close () {
      this.reset()
      this.visible = false
    },
    onExpand (expandedKeys) {
      this.expandedKeysss = expandedKeys
      this.autoExpandParent = false
    },
    reset () {
      this.expandedKeysss = []
      this.checkedKeys = []
      this.defaultCheckedKeys = []
      this.loading = false
    },
    handleCancel () {
      this.close()
    },
    handleSubmit () {
      const _this = this
      _this.loading = true
      saveRolePermission(_this.roleId,_this.checkedKeys).then((res) => {
        this.$notification.success({
          message: '提示',
          description: res.message || '保存角色授权成功',
          duration: 3
        })
        _this.loading = false
        _this.close()
      }).catch(() => {
        _this.$notification.error({
          message: '错误',
          description: '保存角色授权成失败',
          duration: 3
        })
      })
    }
  },
  watch: {
    visible () {
      const _this = this
      if (_this.visible) {
        getPermissionTree({ enable : true }).then((res) => {
          _this.treeData = res.data
          _this.allTreeKeys = res.data.map(item => item.id)
          queryRolePermission(this.roleId).then((res) => {
            _this.checkedKeys = res.data.map(item => item.id)
            _this.defaultCheckedKeys = res.data.map(item => item.id)
            _this.expandedKeysss = this.allTreeKeys
          })
        })
      }
    }
  }
}

</script>
<style scoped>
  .drawer-bootom-button {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>
